import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { map, take, filter } from 'ramda';

import { createSummaryTile } from '../../containers/SummaryLoaderContainer';
import { formatDate } from 'lib/dateDisplay';

import { path } from 'routes/Documents/routes/QualityOfLife';
import calculate15D from 'routes/Documents/routes/QualityOfLife/components/CalculatorField/calculate15D';
import calculateEQ5D from 'routes/Documents/routes/QualityOfLife/components/CalculatorField/calculateEQ5D';

import Graph from './Graph';

import icon from '../../assets/qol.svg';

const predicate = d => d.sections;

const calculate = (documentType, sections) => {
  return documentType === 'eq5d' ? calculateEQ5D(sections) : calculate15D(sections);
};

const View = ({ data, localeMessage }) => (
  <Grid fluid>
    <Row middle="xs" center="xs">
      {map(d => (
        <Col xs={6} key={d.documentId}>
          <Row center="xs" middle="xs">
            <Col xs>
              <Graph
                documentType={d.documentType}
                sections={d.sections}
                calculatedValue={calculate(d.documentType, d.sections)}
                localeMessage={localeMessage}
              />
            </Col>
          </Row>
          <Row center="xs" middle="xs">
            <Col xs>
              <p>
                <b>{d.documentType === 'eq5d' ? 'EQ-5D' : '15D'}</b> : {formatDate(d.createDate)}
              </p>
            </Col>
          </Row>
        </Col>
      ))(
        take(
          2,
          filter(
            predicate,
            data.sort((a, b) => {
              return b.createDate - a.createDate;
            }),
          ),
        ),
      )}
    </Row>
  </Grid>
);

View.propTypes = {
  localeMessage: PropTypes.func.isRequired,
  data: PropTypes.array,
};

export default createSummaryTile(View, {
  module: ['qualityoflife', 'eq5d'],
  localeId: 'qualityoflife.generic.title',
  routeTo: path,
  icon,
});
